import { applyToAllRTFVariants } from '@/components/atoms/richTextField/utils';
import { BlockComponentModel } from '@/components/cms/types/blok-component';

import Heading from '@/decodo/components/atoms/Heading';
import RichTextFieldSB, {
  RichTextFieldStrapiProps,
} from '@/decodo/components/atoms/RichTextField/RichTextFieldStrapi';
import { AccordionItemProps } from '@/decodo/components/molecules/accordion/AccordionItem';
import AccordionList from '@/decodo/components/molecules/accordion/AccordionList';

export interface AccordionListStrapiProps {
  accordionList: {
    header: string;
    content: RichTextFieldStrapiProps['text'];
  }[];
}

interface AccordionListProps {
  internal?: {
    ContainerProps?: React.HTMLAttributes<HTMLDivElement>;
    accordionItem: Partial<AccordionItemProps>;
  };
}

export default function AccordionListStrapi({
  block,
  internal,
}: BlockComponentModel<AccordionListStrapiProps> & AccordionListProps) {
  const { accordionList } = block;
  const { accordionItem, ContainerProps } = internal || {};

  const formattedAccordionList =
    accordionList?.map((item, index) => ({
      header: (
        <Heading
          level='h3'
          classNames={{ root: 'text-subtitle-l-d' }}
          data-tracker-context={`accordion-header-${index}`}
        >
          {item.header}
        </Heading>
      ),
      children: (
        <RichTextFieldSB
          block={{ text: item.content }}
          classNames={{
            ...applyToAllRTFVariants('text-mono'),
            link: { root: 'text-tertiary-500' },
          }}
        />
      ),
    })) || [];

  return (
    <AccordionList
      accordionList={formattedAccordionList}
      internal={{ accordionItem, ContainerProps }}
    />
  );
}
